export const BATCH_TRANSACTION_STATUS_OPTIONS = [
  { value: "all", label: "All Statuses" },
  { value: "COMPLETED", label: "Completed" },
  { value: "PENDING", label: "Pending" },
  { value: "PROCESSING", label: "Processing" },
  { value: "PENDING_CALLBACK", label: "Pending Callback" },
  { value: "FAILED", label: "Failed" },
  { value: "VALIDATION_FAILED", label: "Validation Failed" },
];

export const BATCH_TRANSACTION_STATUS_VALUE_BY_LABEL = Object.fromEntries(
  BATCH_TRANSACTION_STATUS_OPTIONS.filter((o) => o.value !== "all").map((o) => [
    o.label,
    o.value,
  ]),
);

export const DEFAULT_BATCH_TRANSACTIONS_FILTERS = {
  searchQuery: "",
  dateRange: { startDate: null, endDate: null },
  status: "all",
};

export const DEFAULT_BATCH_TRANSACTIONS_PAGINATION = {
  pageIndex: 0,
  pageSize: 10,
};
